export const T_ISpinViewConditionComponent = Symbol('ISpinViewConditionComponent');
export const T_SpinViewMachineListener = Symbol('SpinViewMachineListener');
export const T_IconRespinFeatureProvider = Symbol('IconRespinFeatureProvider');
export const T_RespinShowWinProvider = Symbol('RespinShowWinProvider');
export const T_IconEnumeratorComponent = Symbol('IconEnumeratorComponent');
export const T_InitialReelsComponent = Symbol('InitialReelsComponent');
export const T_StagedFreeSpinsCollectConfig = Symbol('StagedFreeSpinsCollectConfig');
export const T_StackedReelsStopSlotActionConfig = Symbol('StackedReelsStopSlotActionConfig');
export const T_IFadeReelsProvider = Symbol('IFadeReelsProvider');
export const T_CharacterAnimationProvider = Symbol('CharacterAnimationProvider');
export const T_PersonalJackpotCounterProvider = Symbol('PersonalJackpotCounterProvider');
export const T_SlotSession = Symbol('SlotSession');
export const T_GameConfigController = Symbol('GameConfigController');
export const T_IStartSlotActionProvider = Symbol('IStartSlotActionProvider');
export const T_ISpinParams = Symbol('ISpinParams');
export const T_ISpinController = Symbol('ISpinController');
export const T_ISlotPrimaryAnimationProvider = Symbol('ISlotPrimaryAnimationProvider');
export const T_FreeSpinsSoundModelComponent = Symbol('FreeSpinsSoundModelComponent');
export const T_BaseSlotGame = Symbol('BaseSlotGame');
export const T_IFreeSpinsModeProvider = Symbol('IFreeSpinsModeProvider');
export const T_AbstractIconResourceProvider = Symbol('AbstractIconResourceProvider');
export const T_WinMovieSceneProvider = Symbol('WinMovieSceneProvider');
export const T_InstantCoinsAnimationProvider = Symbol('InstantCoinsAnimationProvider');
export const RESOURCES_COMPONENT_TOKEN = Symbol('ResourcesComponent');
export const T_UiSoundModelComponent = Symbol('UiSoundModelComponent');
export const T_IMigratingWildConfigProvider = Symbol('IMigratingWildConfigProvider');
export const T_IProgressiveBonusDependencyProvider = Symbol('IProgressiveBonusDependencyProvider');
export const T_IconModelComponent = Symbol('IconModelComponent');
export const T_IconsSceneObjectComponent = Symbol('IconsSceneObjectComponent');
export const T_IconsSoundModelComponent = Symbol('IconsSoundModelComponent');
export const T_GameStateMachineNotifierComponent = Symbol('GameStateMachineNotifierComponent');
export const T_FreeSpinElemetsProvider = Symbol('FreeSpinElemetsProvider');
export const T_StartFreeSpinsPopupComponent = Symbol('StartFreeSpinsPopupComponent');
export const T_JackPotWinPopupComponent = Symbol('JackPotWinPopupComponent');
export const T_EndFreeSpinsPopupComponent = Symbol('EndFreeSpinsPopupComponent');
export const T_BonusRecoveryPopupComponent = Symbol('BonusRecoveryPopupComponent');
export const T_ScatterGameProvider = Symbol('ScatterGameProvider');
export const T_BonusGameProvider = Symbol('BonusGameProvider');
export const T_OptionalLoader = Symbol('OptionalLoader');
export const T_IReelsConfigProvider = Symbol('IReelsConfigProvider');
export const T_ProgressiveBreakerProvider = Symbol('ProgressiveBreakerProvider');
export const T_ProgressiveBonusAnimationProvider = Symbol('ProgressiveBonusAnimationProvider');
export const T_BigWinPopupProvider = Symbol('BigWinPopupProvider');
export const T_ISlotAnimationController = Symbol('ISlotAnimationController');
export const T_WinLineActionComponent = Symbol('WinLineActionComponent');
export const T_IGameParams = Symbol('IStorageRepositoryProvider');
export const T_AnticipationAnimationProvider = Symbol('AnticipationAnimationProvider');
export const T_RegularSpinsSoundModelComponent = Symbol('RegularSpinsSoundModelComponent');
export const T_ISlotGameEngineProvider = Symbol('ISlotGameEngineProvider');
export const T_IStopSlotActionProvider = Symbol('IStopSlotActionProvider');
export const T_IFeatureWinHolder = Symbol('IFeatureWinHolder');
export const T_IDelayedActionHolder = Symbol('IDelayedActionHolder');
export const T_IProgressiveBonusActionsProvider = Symbol('IProgressiveBonusActionsProvider');
export const T_IFreeSpinsPopupViewUpdater = Symbol('IFreeSpinsPopupViewUpdater');
export const T_IWinLineActionProvider = Symbol('IWinLineActionProvider');
export const T_IWinLineStrategyProvider = Symbol('IWinLineStrategyProvider');
export const T_IBonusExternalEventAsyncProcessor = Symbol('IBonusExternalEventAsyncProcessor');
export const T_ISlotPrimaryActionsProvider = Symbol('ISlotPrimaryActionsProvider');
export const T_IGameConfigProvider = Symbol('IGameConfigProvider');
export const T_ILinesModelProvider = Symbol('ILinesModelProvider');
export const T_ISlotPopupCoordinator = Symbol('ISlotPopupCoordinator');
export const T_ISlotGame = Symbol('ISlotGame');
export const T_SceneCache = Symbol('SceneCache');
export const T_EpicWinPopupProvider = Symbol('EpicWinPopupProvider');
export const T_BaseSlotSoundController = Symbol('BaseSlotSoundController');
export const T_IconWinLinesProvider = Symbol('IconWinLinesProvider');
export const T_EndBonusGameComponent = Symbol('EndBonusGameComponent');
export const T_StickyMaxBetProvider = Symbol('StickyMaxBetProvider');
export const T_BalanceListenerProvider = Symbol('BalanceListenerProvider');
export const T_AnimationAvailabilityProvider = Symbol('AnimationAvailabilityProvider');
export const T_AutoSpinPanelViewListener = Symbol('AutoSpinPanelViewListener');
export const T_FastSpinDoClickActionProvider = Symbol('FastSpinDoClickActionProvider');
export const T_EndFreeSpinTriggerProvider = Symbol('EndFreeSpinTriggerProvider');
export const T_AntiCheatProvider = Symbol('AntiCheatProvider');
export const T_IIconDrawOrderCalculator = Symbol('IIconDrawOrderCalculator');
export const T_IReelsEngineProvider = Symbol('IReelsEngineProvider');
export const T_ICustomWinLinesSoundActionProvider = Symbol('ICustomWinLinesSoundActionProvider');
export const T_IInitialReelsProvider = Symbol('IInitialReelsProvider');
export const T_DynamicDrawOrdersProvider = Symbol('DynamicDrawOrdersProvider');
export const T_FreeSpinsLogoComponent = Symbol('FreeSpinsLogoComponent');
export const T_ElementsStateController = Symbol('ElementsStateController');
export const T_JackpotConfiguredBetsController = Symbol('JackpotConfiguredBetsController');
export const T_Game112StartFreeSpinsPopupController = Symbol(
  'Game112StartFreeSpinsPopupController'
);
export const T_ILogoAnimationProvider = Symbol('ILogoAnimationProvider');
export const T_AbstractIconStopbehaviorProvider = Symbol('AbstractIconStopbehaviorProvider');
export const T_Game112IconStopbehaviorProvider = Symbol('Game112IconStopbehaviorProvider');
export const T_Game112PayTablePopupProvider = Symbol('Game112PayTablePopupProvider');
export const T_Game112EndFreeSpinsPopupComponent = Symbol('Game112EndFreeSpinsPopupComponent');
export const T_Game112IconsSoundModelComponent = Symbol('Game112IconsSoundModelComponent');
export const T_SoundConfigurationProvider = Symbol('SoundConfigurationProvider');
export const T_TotalWinCoinsProvider = Symbol('TotalWinCoinsProvider');
export const T_AutoSpinPanelViewController = Symbol('AutoSpinPanelViewController');
export const T_HudStateController = Symbol('HudStateController');
export const T_FastSpinsController = Symbol('FastSpinsController');
export const T_BeforeStickyActionComponent = Symbol('BeforeStickyActionComponent');
export const T_AfterShortWinLinesActionProvider = Symbol('AfterShortWinLinesActionProvider');
export const T_SingleSceneIconStopBehaviourProvider = Symbol(
  'SingleSceneIconStopBehaviourProvider'
);
export const T_MultiSceneIconWithValuesProvider = Symbol('MultiSceneIconWithValuesProvider');
export const T_FooterWithPlaceholderComponent = Symbol('FooterWithPlaceholderComponent');
export const T_LinesSceneObjectComponent = Symbol('LinesSceneObjectComponent');
export const T_LinesSceneObject = Symbol('LinesSceneObject');
export const T_LineModel = Symbol('LineModel');
export const T_SubstituteIconComponent = Symbol('SubstituteIconComponent');
